export default "__VITE_ASSET__FIVKHejH__"